import { openNavbarAtom } from "@models/state/cart/index";
import { useAtom } from "jotai";

export function useResponsiveNavbar(openDefault = false) {

    const [open, setOpen] = useAtom(openNavbarAtom);
    
    
    function openDrawer() {
      setOpen(!open);
    }
    
    return {
      models: {
        open,
      },
      operations: {
        openDrawer,
      },
    };
  }